<div class="navbar-container">
  <betStopReason-component
    page="header"
    [betStopReasonId]="this.betStopReasonEvent.betStopReasonId"
    [teamScore]="this.betStopReasonEvent.teamScore"
    [homeTeamName]="this.betStopReasonEvent.homeTeamName"
    [awayTeamName]="this.betStopReasonEvent.awayTeamName"
    [isLive]="true">
    <div class="box logo-container" [routerLink]="['/home']">
      <image-loader-utils extraClasses="logo" url="logo" [shared]="false" imageFormat="png"></image-loader-utils>
    </div>
  </betStopReason-component>

  <div class="box mid whiteText">
    <div class="navbar-item" [routerLink]="['/sports']" [ngClass]="{ active: currentRoute === '/sports' }">
      {{ 'Sports' | translate }}
    </div>
    <div class="navbar-item" [routerLink]="['/live']" [ngClass]="{ active: currentRoute === '/live' }">
      {{ 'live' | translate }}
    </div>
    <div class="navbar-item" [routerLink]="['/account/bet-slip']" [ngClass]="{ active: currentRoute === '/account/bet-slip' }">
      {{ 'MyBets' | translate }}
    </div>

    <ng-container *ngIf="this._UserHelper?.customerUser?.IsView === 'True'">
      <ng-container [ngSwitch]="['p1012'] | getProductName">
        <ng-container *ngSwitchCase="'p1012'">
          <div class="navbar-item header-navbar-casino-icon-with" [routerLink]="['/casino/lobby/1/0']">
            {{ 'casino.lobby.slot' | translate }}
          </div>
          <div class="navbar-item header-navbar-casino-icon-with" [routerLink]="['/casino/lobby/2/0']">
            {{ 'casino.lobby.livecasino' | translate }}
          </div>
          <div class="navbar-item header-navbar-casino-icon-with" [routerLink]="['/casino/lobby/5/0']">
            {{ 'casino.lobby.virtual' | translate }}
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault></ng-container>
      </ng-container>
    </ng-container>
  </div>

  <div
    class="box account margin-left-30"
    wallet-container-dropdown
    [ngClass]="{
      'sign-in': this._UserHelper.isSignedIn,
      'without-register': !this.IsRegisterActive
    }">
    <ng-container *ngIf="!this._UserHelper.isSignedIn">
      <div class="time-container navbar-right-side-item">
        {{ narvbarDateTime }}
      </div>
      <div class="btn navbar-small basic login-button btn-h-30 navbar-right-side-item" (click)="loginDropDownOpen()">
        <div class="btn-text">{{ 'login' | translate }}</div>
      </div>
      <div [class]="'login-desktop-dropdown navbar-right-side-item ' + (('product' | getEnv) === 'p1012' ? 'full-screen-login' : '')" *ngIf="this._UiHelper.loginDropDownIsOpen">
        <login-base-component></login-base-component>
      </div>

      <ng-container [ngSwitch]="['p1012'] | getProductName">
        <ng-container *ngSwitchCase="'p1012'"></ng-container>
        <ng-container *ngSwitchDefault>
          <div class="btn navbar-small btn-h-30 colored register-button navbar-right-side-item" [routerLink]="['/register']" *ngIf="this.IsRegisterActive">
            <div class="btn-text">{{ 'Register' | translate }}</div>
            <div class="btn-icon register-icon">
              <image-loader-utils url="18" extraClasses="svg-18-navbar"></image-loader-utils>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="this._UserHelper.isSignedIn">
      <div id="searchMenu" class="header-container-uncolor">
        <div class="header-content">
          <div id="nav-search">
            <input
              [formControl]="searchValue"
              #search
              type="search"
              [placeholder]="'Search' | translate"
              [ngClass]="{ filled: filled }"
              (blur)="filled = search.value ? true : false"
              (input)="onInputChange($event)" />
          </div>
        </div>
      </div>
      <div id="balance" class="navbar-menu-item">
        <span> {{ this._UserHelper.walletList[0]?.Balance | balanceFormat }}</span>
      </div>
      <div id="my-bets" class="navbar-menu-item" [routerLink]="['/account/bet-slip']">
        <image-loader-utils url="mybets" extraClasses="navbar-svg"></image-loader-utils>
        <span>My Bets</span>
      </div>
      <div id="messages" class="navbar-menu-item" [routerLink]="['/account/my-messages']">
        <image-loader-utils url="message" extraClasses="navbar-svg"></image-loader-utils>

        <span>Messages</span>
      </div>
      <div id="account" class="navbar-menu-item" [routerLink]="['/account/profile']">
        <image-loader-utils url="account-user" extraClasses="navbar-svg"></image-loader-utils>

        <span>Account</span>
      </div>
    </ng-container>
    <!-- <div class="theme-button navbar-right-side-item setting-button" (click)="settingsDropDownOpen()">
      <image-loader-utils url="settings" extraClasses="theme-svg"></image-loader-utils>
    </div> -->
    <div class="setting-dropdown" *ngIf="this._UiHelper.settingsDropDownIsOpen">
      <div class="lang-button navbar-right-side-item" (click)="langDropdownOpen()">
        <div class="flag">
          <image-loader-flag-utils [url]="_LocalizationService.ISOABBR" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
        </div>
        <div class="languages-dropdown" *ngIf="this._UiHelper.langDropdownIsOpen">
          <div class="dropdown-item" (click)="changeActiveLanguage(x.langCode)" *ngFor="let x of langDatasArry">
            <div class="flag">
              <image-loader-flag-utils [url]="x.ISOabbr" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
            </div>
            <div class="flag-text">{{ x.langNativeNames }}</div>
          </div>
        </div>
      </div>
      <spinner-utils [spinnerState]="this._UiHelper.navbarDarkThemeState">
        <div class="theme-button theme-change-box navbar-right-side-item" (click)="changeTheme()">
          <image-loader-utils [url]="_UiHelper.currentTheme === 'theme-light' ? 'theme-dark' : 'theme-light'" extraClasses="theme-svg"></image-loader-utils>
        </div>
      </spinner-utils>
    </div>
  </div>
</div>
<div class="navbar-container mobile">
  <div [class]="'login-desktop-dropdown navbar-right-side-item ' + (('product' | getEnv) === 'p1012' ? 'full-screen-login' : '')" *ngIf="this._UiHelper.loginDropDownIsOpen">
    <login-base-component></login-base-component>
  </div>
  <ng-container [ngSwitch]="['p1012'] | getProductName">
    <ng-container *ngSwitchCase="'p1012'"></ng-container>
    <ng-container *ngSwitchDefault>
      <div class="search">
        <image-loader-utils url="search" extraClasses="searchsvg"></image-loader-utils>
      </div>
    </ng-container>
  </ng-container>
  <betStopReason-component
    page="header"
    [betStopReasonId]="this.betStopReasonEvent.betStopReasonId"
    [teamScore]="this.betStopReasonEvent.teamScore"
    [homeTeamName]="this.betStopReasonEvent.homeTeamName"
    [awayTeamName]="this.betStopReasonEvent.awayTeamName"
    [isLive]="true">
    <div class="logo-container" [routerLink]="['/home']" (click)="this._UiHelper.p1001SetMatchDetailDialog('close')">
      <image-loader-utils extraClasses="logo" url="logo" [shared]="false" imageFormat="png"></image-loader-utils>
    </div>
  </betStopReason-component>
  <div class="search-container" [routerLink]="['/search']">
    <image-loader-utils url="search-mobile" extraClasses="search-mobile-icon"></image-loader-utils>
  </div>
  <div class="user mobile-user-circle" [ngClass]="{ 'user-circle-container': this._UserHelper.isSignedIn }">
    <ng-container *ngIf="this._UserHelper.isSignedIn">
      <div id="rightMenuUserIcon" class="rightMenuUserIcon" (click)="openSideBar()">
        <image-loader-utils url="user-mobile" extraClasses="user-icon white-color"></image-loader-utils>
      </div>
      <div class="customer-balance">
        <ng-container *ngIf="_UserHelper.getBalanceVisibility(parseInt(customerInfo.CustomerId)); else hiddenBalance">
          {{ customerInfo.Balance | balanceFormat }}
        </ng-container>
        <ng-template #hiddenBalance> ****</ng-template>
      </div>
    </ng-container>
  </div>
  <div id="rightSidenav" class="sidenav">
    <right-menu [isCasino]="this.isCasino"></right-menu>
  </div>

  <div id="leftSidenav" class="sidenav side-menu-left">
    <left-menu></left-menu>
  </div>
</div>
<dimmer-utils></dimmer-utils>
